import type { ComponentPropsWithoutRef } from 'react'
import styles from './StyledLink.module.css'

export const StyledLink = (props: ComponentPropsWithoutRef<'a'>) => (
  <a className={styles.link} {...props} />
)
